/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* 
This is recent transactions page having transactions from operative and credit card accounts */
/* <script type="text/javascript" src="http://maps.googleapis.com/maps/api/js?sensor=false"></script> */
import {
    html,
    Polymer
} from '@polymer/polymer/polymer-legacy.js';


const template = html`
		<style include="app-styles">
           
        </style>
        
        <app-media-query phone={{phone}} desktop={{desktop}} tablet={{tablet}}></app-media-query>
        <template is="dom-repeat" items={{quickList}}>
            <div class="outlineOffset cursor-pointer margin-b-zero margin-t-zero mdl-cell mdl-grid mdl-grid--no-spacing mdl-cell--12-col" tabindex="0" on-keydown="_gotoTransactionDDA" on-tap="_gotolinks">
                    <div class="mdl-cell mdl-cell--2-col-phone mdl-cell--12-col-desktop mdl-grid">
                      <div>
                        <a class="text-decoration-none text-brand-color font-size-m">{{item.linkName}}</a>
                    </div>  
                </div>
                <div class="full-width mdl-grid">
                      <div class="border-b-1px full-width"></div>
                  </div> 
        </template>
        <app-dialog id="nocards" elementid="ccnocards">
                <div class="mdl-grid">
                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">
                            <oe-i18n-msg class="header-dark padding-t-zero content-align-center" msgid="m_nocccard"></oe-i18n-msg>
                        </div>             
                </div>            
        </app-dialog>
		
		`;

Polymer({
    is: 'dashboard-quick-links',
    _template: template,
    properties: {
        quickList: {
            type: Array,
            value: [
                { linkName: 'Make ADHOC Payment', url: '/adhoc-payment' },
                { linkName: 'Block Lost Card', url: '/disable-card-landing' },
                { linkName: 'Change Password', url: '/changepassword' }
            ]
          },
          fromPage: {
            type: String,
            notify: true
        }
    },
    _gotolinks: function (e) {
        this.fromPage = "dashboard-quick-links";
        var self = this;
        if (e.model.item.linkName == "Make ADHOC Payment") {
            this.dispatchEvent(new CustomEvent('payTypeEvent'), true);
        } else if(e.model.item.linkName == "Block Lost Card") {
                var fetchCCList = document.createElement("oe-ajax");
                fetchCCList.contentType = "application/json";
                fetchCCList.handleAs = "json";
                fetchCCList.url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/creditcards";
                fetchCCList.method = "GET";
                oeAjaxEventListner(fetchCCList);
                fetchCCList.generateRequest();
                //var self = this;
                fetchCCList.addEventListener('response', function (event) {
                    if (event.detail.response.length <= 0) {
                        self.$$("#nocards").$$("#ccnocards").open();
                    } else {
                        window.oe_navigate_to(e.model.item.url, self.fromPage);
                    }
                })
                fetchCCList.addEventListener("error", function (e) {
                    self.$$("#nocards").$$("#ccnocards").open();
                });
        } else {
              window.oe_navigate_to(e.model.item.url, self.fromPage);
        }
    }
});
